export { default } from "./InputList"
